import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Proflie } from './profile';
import { Contact } from './contact'; 
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class HttpService {

  category: string;
  baseUrl = 'http://www.billyin.ca/server/';
  // baseUrl = 'http://localhost/profile/';
  token: string = 'IGQVJVQ243SkZAQLU15OE5lbUtyVmJ3cGpfUmdiZATB1SXdrakFiV196ZATY2bDY0UjctVTRSc1FxVy1NaEZA6NkM0S3JFeGIzNlN6TkxhdlQ4SDE3b2lsWDJLTXJxdk1ralJXckRRUUotSXNSS01GNTFISwZDZD';
  

  searchOption=[];
  public postsData: Proflie[];

  constructor(private _http: HttpClient) { }

  public getIPAddress()  
  {  
    return this._http.get("http://api.ipify.org/?format=json");  
  } 

  getWebsites(category, number) {
    this.category = category != '' ? category: 'all';
    if(number != null) {
      return this._http.get<Proflie[]>(this.baseUrl + 'getItems.php?postType=websites&category=' + this.category + '&number=' + number);
    }else {
      return this._http.get<Proflie[]>(this.baseUrl + 'getItems.php?postType=websites&category=' + this.category);
    }    
  }

  getWebsiteDetail(url){
    return this._http.get<Proflie[]>(this.baseUrl + 'getWebsiteDetail.php?postType=websites&url='+url);
  }

  getPhotos(category, number) {
    this.category = category != '' ? category: 'all';
    if(number != null) {
      return this._http.get<Proflie[]>(this.baseUrl + 'getItems.php?postType=photography&category=' + this.category + '&number=' + number);
    }else {
      return this._http.get<Proflie[]>(this.baseUrl + 'getItems.php?postType=photography&category=' + this.category);
    }    
  }

  getPhotoDetail(url){
    return this._http.get<Proflie[]>(this.baseUrl + 'getWebsiteDetail.php?postType=photography&url='+url);
  }

  getSearchItems() {
    return this._http.get<Proflie[]>(`${this.baseUrl}getSearchItems.php`);
  }
  getPosts(): Observable<Proflie[]>{
      return this._http.get<Proflie[]>(`${this.baseUrl}getSearchItems.php`);
  }

  filteredListOptions() {
    let posts = this.postsData;
        let filteredPostsList = [];
        for (let post of posts) {
            for (let options of this.searchOption) {
                if (options.title === post.title) {
                  filteredPostsList.push(post);
                }
            }
        }
        console.log(filteredPostsList);
        return filteredPostsList;
  }

  sentForm(contact: Contact){
    console.log('contact: '+ contact);
    return this._http.post(this.baseUrl + 'sentForm.php', contact);
  }

  instagramPost () {
    let url = 'https://api.instagram.com/v1/users/391477/media/recent/?access_token=' + this.token;
    try {
      return this._http.get(url);
    }
    catch (err) {
      console.error(err);
      return err;
    };
  }

  facebookPost () {
    let url = 'https://graph.facebook.com/v6.0/me/albums?fields=link%2Cname%2Cpicture%7Bheight%2Curl%2Cwidth%7D&limit=4&access_token=EAAHZAmCT43wQBAJxOWqjZAVYwKoXGarS7w3T2J3aCOZADbagZBZB011SwiueYENyVnIdVU5QUwfI6tIDUqNY2GqIPZACEYK0WpnRnRhwIs9WVRVYvVtZBZB1OS3GHS0bgWmodlzQIT6xgjY7uqtyNp7MC8NnQQOFI0qoaowYkNAYwWHOrgAYnVLCJRwQbYIjSifqZB5HHOI7ZChgZDZD';
    try {
      return this._http.get(url);
    }
    catch (err) {
      console.error(err);
      return err;
    };
  }

  tumblrPost () {
    let  api_key = 'd4CvRnKCmACz3x2daXvk5Hz7rOvPBtTvwtn3jlRmfwGWzF6Qgc';
    let  limit = 6;
    try {
      return this._http.get('https://api.tumblr.com/v2/blog/bill-yin.tumblr.com/posts/photo?api_key='+ api_key + '&limit=' + limit);
    }
    catch (err) {
      console.error(err);
      return err;
    };
  }

  // deleteStudent(id:number) {
  //   return this._http.delete<Proflie[]>('http://localhost/angular/delete.php?id='+id);
  // }

  // createStudent(proflie: Proflie) {
  //   return this._http.post('http://localhost/angular/create.php', student);
  // }

  // updateStudent(proflie: Proflie) {
  //   return this._http.put('http://localhost/angular/update.php?id=' + student.sId, student);
  // }

  // getById(id:number){
  //   return this._http.get<Proflie[]>('http://localhost/angular/getStudentById.php?id='+id);
  // }
}
